import { render, staticRenderFns } from "./prizeLogList.vue?vue&type=template&id=4df3634d&scoped=true&"
import script from "./prizeLogList.vue?vue&type=script&lang=js&"
export * from "./prizeLogList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df3634d",
  null
  
)

export default component.exports